import * as tracker from 'analytics/tracker';

import { QuoteRequestFormProduct } from 'app/api/products/types';
import { formatProductAnalyticsData } from './formatProductAnalyticsData';

export const getQuoteRequestedEventProducts = (data: QuoteRequestFormProduct[]): tracker.apiObject[] => {
  const results = data.map(({ value, ...product }) => ({
    ...formatProductAnalyticsData({ product }),
    amount: value,
  })) as unknown as tracker.apiObject[];

  return results;
};
